module.exports = __webpack_public_path__ + "static/media/icon-big-arrow.2a6c207e.svg";